/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ACSBaseService } from '../acs-base-service';
import { ACSApiConfiguration } from '../acs-api-configuration';
import { ACSStrictHttpResponse } from '../acs-strict-http-response';

import { voipGetAnonymousUserPost } from '../fn/voip/voip-get-anonymous-user-post';
import { VoipGetAnonymousUserPost$Params } from '../fn/voip/voip-get-anonymous-user-post';
import { voipGetUserGet } from '../fn/voip/voip-get-user-get';
import { VoipGetUserGet$Params } from '../fn/voip/voip-get-user-get';
import { VoipUserModel } from '../models/voip-user-model';

@Injectable({ providedIn: 'root' })
export class ACSVoipService extends ACSBaseService {
  constructor(config: ACSApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `voipGetUserGet()` */
  static readonly VoipGetUserGetPath = '/Voip/GetUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voipGetUserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  voipGetUserGet$Response(params?: VoipGetUserGet$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<VoipUserModel>> {
    return voipGetUserGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voipGetUserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  voipGetUserGet(params?: VoipGetUserGet$Params, context?: HttpContext): Observable<VoipUserModel> {
    return this.voipGetUserGet$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<VoipUserModel>): VoipUserModel => r.body)
    );
  }

  /** Path part for operation `voipGetAnonymousUserPost()` */
  static readonly VoipGetAnonymousUserPostPath = '/Voip/GetAnonymousUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `voipGetAnonymousUserPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  voipGetAnonymousUserPost$Response(params?: VoipGetAnonymousUserPost$Params, context?: HttpContext): Observable<ACSStrictHttpResponse<VoipUserModel>> {
    return voipGetAnonymousUserPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `voipGetAnonymousUserPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  voipGetAnonymousUserPost(params?: VoipGetAnonymousUserPost$Params, context?: HttpContext): Observable<VoipUserModel> {
    return this.voipGetAnonymousUserPost$Response(params, context).pipe(
      map((r: ACSStrictHttpResponse<VoipUserModel>): VoipUserModel => r.body)
    );
  }

}
